module.exports = __webpack_public_path__ + "static/assets/img/polls.3a9ef403.svg";